export default __webpack_public_path__ + "static/person-img1-68195037e0f611656ae83b89788ce8dd.jpg";